import {makeAutoObservable} from "mobx";

export default class OrdersStore {
    constructor() {
        this._orders = [];
        makeAutoObservable(this);
    }


    get orders() {
        return this._orders;
    }

    setOrders(value) {
        this._orders = value;
    }
}